<template lang='pug'>
  router-view
</template>

<script>
export default {
  name: 'IntegrationsHome'
};
</script>

<style scoped>

</style>
